import * as React from 'react';

const PlayIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85.69 85.69" {...props}>
    <path d="M31.62 63.46 63 42.85 31.62 22.23v41.23z" />
    <path d="M31.37 63.92V21.77l32.09 21.08-32.09 21.07Zm.5-41.22V63l30.68-20.15L31.87 22.7Z" />
  </svg>
);

export default PlayIcon;
